import * as types from '../types.js'
import Vue from 'vue'

const state = { status: '', profile: {} }

const getters = {
    getProfile: state => state.profile,
    isProfileLoaded: state => !!state.profile.name,
}

const actions = {
    [types.USER_REQUEST]: ({commit, dispatch}) => {
        commit(types.USER_REQUEST)
        axios.get('api/user').then(resp => {
            commit(types.USER_SUCCESS, resp.data)
        })
        .catch(resp => {
            commit(types.USER_ERROR)
            // if resp is unauthorized, logout, to
            dispatch(types.AUTH_LOGOUT)
        })
    },
    [types.USER_UPDATE_PASSWORD]: ({commit, dispatch}, userData) => {
        return axios.post('api/update_password', {
            ... userData
        })
        .then(resp => {
            console.log('password update complete')
        })
        .catch(err => {
            console.log('rejecting promise...')
            return Promise.reject(err.response.data)
        })
    }
}

const mutations = {
    [types.USER_REQUEST]: (state) => {
        state.status = 'loading'
    },
    [types.USER_SUCCESS]: (state, resp) => {
        state.status = 'success'
        Vue.set(state, 'profile', resp)
    },
    [types.USER_ERROR]: (state) => {
        state.status = 'error'
    },
    [types.AUTH_LOGOUT]: (state) => {
        state.profile = {}
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}